import { Component } from '@angular/core';
import {IconButtonConfig} from "@collab/comp-library";

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent{
    public currentComment=0;
    public currentIndex = 0;
    public prevImageIconButtonConfig: IconButtonConfig = {
        buttonSize: 'large',
        iconURL: 'icon-Chev-Left icon--xxl',
        imageUrl: '',
        text: '',
        linkURL: '',
        outline: true
    };

    public nextImageIconButtonConfig: IconButtonConfig = {
        buttonSize: 'large',
        iconURL: 'icon-Chev-Right icon--xxl',
        imageUrl: '',
        text: '',
        linkURL: '',
        outline: true
    };

    public prevCommentIconButtonConfig: IconButtonConfig = {
        buttonSize: 'large',
        iconURL: 'icon-Chev-Left icon--xl',
        imageUrl: '',
        text: '',
        linkURL: '',
        outline: true
    };

    public nextCommentIconButtonConfig: IconButtonConfig = {
        buttonSize: 'large',
        iconURL: 'icon-Chev-Right icon--xl',
        imageUrl: '',
        text: '',
        linkURL: '',
        outline: true
    };

  public comments=[
    {
        src:'../../../../assets/clients.png',
        comment:" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text eversince the 1500s, when an unknown printer took a galley of type and  scrambled it to make a type specimen book.",
        commenter_name:"Christiana Ritz",
        commenter_designation:"Project Head - Catterpiller"
    },
    {
        src:'../../../assets/profile-image.png',
        comment:" 2nd is the para dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text eversince the 1500s, when an unknown printer took a galley of type and  scrambled it to make a type specimen book.",
        commenter_name:"Ritz",
        commenter_designation:"Project Head - Butterfly",
    },
    {
        src:'../../../assets/profile-image.png',
        comment:" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text eversince the 1500s, when an unknown printer took a galley of type and  scrambled it to make a type specimen book.",
        commenter_name:"Louis",
        commenter_designation:"Team Leader - Silworm"
    }
]
public image = [
    {
      src: "../../../../assets/clientimages/client1.png",
    },
    {
      src: "../../../../assets/clientimages/client2.png",
    },
    {
      src: "../../../../assets/clientimages/client3.png",
    },
    {
      src: "../../../../assets/clientimages/client4.png",
    },
    {
      src: "../../../../assets/clientimages/client5.png",
    },
    {
      src: "../../../../assets/ade_panelimage.png",
    },
    {
      src: "../../../../assets/clientimages/client3.png",
    },
    {
      src: "../../../../assets/clientimages/client5.png",
    },
    {
        src: "../../../../assets/clientimages/client1.png",
      },
    {
      src: "../../../../assets/profile-image.png",
    },
  
  ];

public nextComment(){
    if(this.currentComment<this.comments.length-1){
        this.currentComment++
    }else{
        this.currentComment=0
    }
}
public prevComment(){
    if(this.currentComment>0){
        this.currentComment--;
    }else{
        this.currentComment=0;
    }
  }
  
  public nextImage() {
    if (this.currentIndex < this.image.length - this.currentIndex) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0;
    }
  }
  public prevImage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = 0;
    }
  }
}
